import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_publish_a_report_at_least_every_2_years_regarding'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_publish_a_report_at_least_every_2_years_regarding',
  name: 'Does the facility publish a report (at least every 2 years) regarding its own progress towards social compliance goals and objectives set by the facility?',
  description: '',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-14--2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25490,
  sectionId: '2.2.11.1',
  impactArea: 'Transparency',
  impactAreaId: 'TRANSPARENCY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
